import logo_gyf_wu from '../images/logo_gyf_wu.png'
import vigilado from  '../images/vigilado.png'
export const HeaderComponent = () => {
    return (
        <header className="yellow_bg">
            <div className="container d-flex justify-content-between align-items-center gap-2 gap-lg-0 px-2 px-lg-0">
                <div>
                    <img src={vigilado} alt="Vigilado Superintentencia Financiera de Colombia" 
                    className='img-fluid'/>
                </div>
                <div>
                    <img src={logo_gyf_wu} alt="Logo Giros y Finanzas - Western Union"  className='img-fluid'/>
                </div>
            </div>
        </header>
    )
}